export default "__VITE_ASSET__C5AiV2Qa__"